import React from "react";

export default function Header() {
  return (
    <header>
      <h1>Just Pick One!</h1>
    </header>
  );
}
